import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-beauty-salon-booking-workflow',
  imports: [CommonModule, TranslateModule],
  templateUrl: './beauty-salon-booking-workflow.component.html',
  styleUrl: './beauty-salon-booking-workflow.component.scss',
})
export class BeautySalonBookingWorkflowComponent {}
